
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement,LineController, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2"

ChartJS.register(LineElement, PointElement, LineController, CategoryScale, LinearScale, Title, Tooltip, Legend);

function LineChart(props) {
  const data = {
    labels: props.labels,
    datasets: props.dataSet,
  }
  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 1
          },
        },
      ],
      xAxes: [{
        ticks: {
          display: true,
        }
      }],
    },
  }
  return <Line data={data} options={options} />
}

export default LineChart